import { TransactionEntriesTable } from '@/components/cashflow/transactions/TransactionEntriesTable';
import { FlexCol } from '@/components/common/Flex';
import { Text } from '@/components/common/Typography';
import { CashflowTransactionEntry } from '@common/react/cashflow';

interface BudgetTransactionEntriesTableProps {
    title: string;
    transactionEntries: CashflowTransactionEntry[];
    loading: boolean;
    scrollRef: React.RefObject<HTMLDivElement>;
}

export const BudgetTransactionEntriesTable = ({
    title,
    transactionEntries,
    loading,
    scrollRef,
}: BudgetTransactionEntriesTableProps) => (
    <FlexCol mt={8} gap={2}>
        <Text fontWeight="medium">{title} transactions</Text>
        <TransactionEntriesTable
            transactionEntries={transactionEntries}
            loading={loading}
            scrollRef={scrollRef}
        />
    </FlexCol>
);
